import React from 'react';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

interface BreadcrumbProps {
  homePath: string;
  currentPage: string;
  className?: string; 
  withHoverTransition?: boolean; // Only true for About Us Page
}

const Breadcrumb = ({ 
  homePath, 
  currentPage, 
  className = "", 
  withHoverTransition = false 
}: BreadcrumbProps) => {
  return (
    <div className={`hidden md:flex items-center gap-2 text-base ${className}`}>
      <Link 
        href={homePath} 
        className={`text-gray-500 hover:text-indigo-700 ${
          withHoverTransition ? 'transition-colors duration-200' : ''
        }`}
      >
        Home
      </Link>
      <ChevronRight size={16} className="text-gray-400" />
      <span className="font-medium text-indigo-700">
        {currentPage}
      </span>
    </div>
  );
};

export default Breadcrumb;